import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from '../../../environments/environment';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { HelperService } from '../helper/helper.service';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public apiUrl = environment.apiUrl;

  constructor(public http: Http, public helper: HelperService) {
   }

   getOutTxHistory(address, slice):Observable<any>{
    // return this.http.get(this.apiUrl + '/addresses/'+'0xe88bf2e91f8003c0bfcb88290e821d399141b5a8'+ '/outtxs/' + slice);

    return this.http.get(this.apiUrl + '/addresses/'+ this.helper.accountList[this.helper.slectedAddress] + '/outtxs/' + slice);
   }

   getInTxHistory(address, slice):Observable<any>{
    // return this.http.get(this.apiUrl + '/addresses/'+'0xe88bf2e91f8003c0bfcb88290e821d399141b5a8'+ '/intxs/' + slice);

    return this.http.get(this.apiUrl + '/addresses/'+ this.helper.accountList[this.helper.slectedAddress] + '/intxs/' + slice);
   }
}
